var map = {
	"./duunitori.png": 903,
	"./helios.png": 450,
	"./helios2.png": 458,
	"./logo.png": 153,
	"./matchnplay.png": 953,
	"./nordflix.png": 58,
	"./portfolio.png": 6,
	"./profilePic.png": 565,
	"./tastopia.png": 291,
	"./tastopia2.png": 649,
	"./twilio.png": 736,
	"./xit.png": 281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 323;